module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_6.65a9170e.png";